const SERVICE_KEYS = {
  STAFF_LIST_API: 'StaffListApiService',
  MEMBER_API:'Member',
  AUTH: 'AuthService',
  ADDRESS_VERIFICATION_API: 'AddressVerificationApiService',
  MEMBERSHIP_API:"MembershipApiService,"
};

export default SERVICE_KEYS;
